"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var DataGrid_1 = require("./DataGrid");
var DataGridColors_1 = require("./DataGridColors");
var DefaultFormatter_1 = require("./DefaultFormatter");
var Utils_1 = require("./Utils");
var BodyCell = /** @class */ (function (_super) {
    tslib_1.__extends(BodyCell, _super);
    function BodyCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            if (_this.props.onCellClick) {
                var cell = _this.getCell();
                _this.props.onCellClick(_this.props.row.data, cell, e);
            }
        };
        _this.handleDoubleClick = function (e) {
            if (_this.props.onCellDoubleClick) {
                var cell = _this.getCell();
                _this.props.onCellDoubleClick(_this.props.row.data, cell, e);
            }
        };
        _this.handleContextMenu = function (e) {
            if (_this.props.onCellContextMenu) {
                var cell = _this.getCell();
                _this.props.onCellContextMenu(_this.props.row.data, cell, e);
            }
        };
        return _this;
    }
    BodyCell.prototype.componentDidMount = function () {
        if (this.props.reportWidthFn) {
            this.props.reportWidthFn(this.props.col.name, Utils_1.measureWidth(this));
        }
    };
    BodyCell.prototype.getCell = function () {
        return { colIdx: this.props.colIdx, rowIdx: this.props.rowIdx, colKey: this.props.col.dataKey, rowKey: this.props.row.key };
    };
    BodyCell.prototype.render = function () {
        var _this = this;
        var _a, _b, _c;
        // tslint:disable:deprecation
        var children = this.props.col.cellComponent ? React.createElement(this.props.col.cellComponent, tslib_1.__assign({}, this.props)) : (_c = (_b = (_a = this.props.col).cellFormatter) === null || _b === void 0 ? void 0 : _b.call(_a, this.props), (_c !== null && _c !== void 0 ? _c : React.createElement(DefaultFormatter_1.DefaultFormatter, { value: this.props.value, testId: widgets_1.testId(this.props.rowIdx + '-' + this.props.colIdx, 'Cell') })));
        // tslint:enable:deprecation
        return React.createElement(DataGrid_1.ColumnHeadersContext.Consumer, null, function (showColumnHeaders) {
            return React.createElement("div", { "aria-colindex": _this.props.colIdx + 1, "aria-rowindex": _this.props.rowIdx + (showColumnHeaders ? 2 : 1), "aria-selected": _this.props.isSelected, children: children, className: 'tb-react-dg-bcell', "data-tb-test-id": _this.props.col.name + BodyCell.CellTestIdSuffix, onContextMenu: _this.handleContextMenu, onClick: _this.handleClick, onDoubleClick: _this.handleDoubleClick, style: BodyCell.getStyle(_this.props.isSelected, _this.props.height, _this.props.width, _this.props.showVerticalGridLines), tabIndex: -1, role: 'gridcell' });
        });
    };
    BodyCell.displayName = 'DataGridBodyCell';
    return BodyCell;
}(React.PureComponent));
exports.BodyCell = BodyCell;
(function (BodyCell) {
    function getStyle(isSelected, height, width, showVerticalGridLines) {
        var borderBottomColor = isSelected ? DataGridColors_1.DataGridColors.SelectedGridLine : 'transparent';
        var borderRightColor = showVerticalGridLines ? (isSelected ? DataGridColors_1.DataGridColors.SelectedGridLine : DataGridColors_1.DataGridColors.VerticalGridLine) : 'transparent';
        return {
            backgroundColor: isSelected ? DataGridColors_1.DataGridColors.Selected : undefined,
            borderBottom: "1px solid " + borderBottomColor,
            borderRight: "1px solid " + borderRightColor,
            boxSizing: 'border-box',
            display: 'inline-block',
            height: height,
            lineHeight: height + 'px',
            verticalAlign: 'top',
            width: width
        };
    }
    BodyCell.getStyle = getStyle;
    ;
    BodyCell.CellTestIdSuffix = '-cell';
})(BodyCell = exports.BodyCell || (exports.BodyCell = {}));
exports.BodyCell = BodyCell;
//# sourceMappingURL=BodyCell.js.map